import { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import Header from "../../components/molecules/Header/Header";
import Footer from "../../components/molecules/Footer/Footer";
import { NotifyType } from "../../utils/NotifyType";
import { notify } from "../../utils";
import Loader from "../../components/molecules/Loader";
import { getInvoiceHistory } from "../../api/apimethods";
import InvoiceGrid from "./InvoiceGrid";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
const InvoiceDashboard = () => {
  const enquiryDashboard = [
    {
      columnName: "Invoice Number",
      sortKey: "invoiceNumber",
    },
    {
      columnName: "Reference Number",
      sortKey: "referenceNumber",
    },
    {
      columnName: "Transaction ID",
      sortKey: "transactionID",
    },
    {
      columnName: "Invoice Date",
      sortKey: "invoiceDate",
    },
    {
      columnName: "Amount (SGD)",
      sortKey: "AmountDue",
    },
    {
      columnName: "Payment Status",
      sortKey: "PaymentStatus",
    },
    {
      columnName: "Action",
      sortKey: "",
    },
  ];

  const [data, setData] = useState<any[]>([]);
  const [zipdata, setZipData] = useState("");
  const { message } = notify();
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [showError, setShowError] = useState(false);
  const [showGrid, setShowGrid] = useState(false);
  const [referenceError, setreferenceError] = useState(false);
  const [isLoading] = useState<boolean>(false);
  const [headers] = useState<any[]>(enquiryDashboard);
  const [searchLoading, setSearchLoading] = useState<boolean>(false);
  const [referenceNumber, setReferenceNumber] = useState<string | null>(null);
  const [pageLoading, setPageLoading] = useState<boolean>(false);

  const handleReset = () => {
    setShowGrid(false);
    setDateFrom("");
    setDateTo("");
    setShowError(false);
    setData([]);
    setZipData("");
  };

  const LoadDate = () =>
  {
      const fdate = new Date();
        fdate.setDate(fdate.getDate() - 30);
        setDateFrom(fdate.toISOString().split("T")[0]);
        
        const tdate = new Date();
        setDateTo(tdate.toISOString().split("T")[0]);
  }

  const getNextDay = (date: any) => {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate());
    return newDate.toISOString().split("T")[0];
  };

  const getTodayDate = () => {
    return new Date().toISOString().split("T")[0];
  };
  useEffect(() => {
    const fetchDefaultData = async () => {
      try {
        setPageLoading(true);

        const getUserInfo = localStorage.getItem("app-data");
        const userInfo = JSON.parse(getUserInfo || "{}");
        setReferenceNumber(userInfo?.user?.idNo || "");

        LoadDate();
        
        const responses = await getInvoiceHistory(
          dateFrom || null,
          dateTo || null
        );

        const { invoices, zipBase64 } = responses.data;
        setData(invoices);
        setZipData(zipBase64?.toString() || "");
        setShowGrid(invoices.length > 0);

        if (invoices.length === 0) {
          message(NotifyType.Info, "No invoice found");
        }
      } catch (error) {
        console.error("Failed to fetch invoice:", error);
        message(NotifyType.Error, "Failed to load invoice");
      } finally {
        setPageLoading(false);
      }
    };

    fetchDefaultData();
  }, []);
  const handleSearch = async () => {
    try {     
      if (!dateFrom) {
        message(NotifyType.Error, "Please enter From date");
        setShowError(true);
        return;
      }      

      if (!dateTo) {
        message(NotifyType.Error, "Please enter To date");
        setShowError(true);
        return;
      }      

      if ((dateFrom && !dateTo) || (!dateFrom && dateTo)) {
        message(NotifyType.Error, "Please enter both From and To dates");
        setShowError(true);
        return;
      }
      setSearchLoading(true);
      setShowError(false);
      setPageLoading(true);
      const responses = await getInvoiceHistory(
        dateFrom || null,
        dateTo || null
      );      
      const { invoices, zipBase64 } = responses.data;
      setData(invoices);
      setZipData(zipBase64?.toString() || "");
      setShowGrid(invoices.length > 0);

      if (invoices.length === 0) {
        message(NotifyType.Info, "No Invoice(s) found");
      }

      setSearchLoading(false);
      setPageLoading(false);
    } catch (error) {
      console.error("Search error:", error);
      setSearchLoading(false);
      setPageLoading(false);
      message(NotifyType.Error, "Failed to fetch invoice details");
    }
  };

  return (
    <>
      <Header />
      <center>
        <h3 className="savedraft">Invoice Dashboard</h3>
      </center>
      <Container>
        <form>
          <div className="row">
            <div className="col-lg-12">
              <div className="col-md-11">
                <div className="info-content">

                  <div className="row mb-3 d-none">
                    <div className="col-lg-3">
                      <label className="col-form-label">UEN/Indentification Number *</label>
                    </div>
                    <div className="col-lg-6">
                      <input
                        type="text"
                        className="form-control"
                        readOnly
                        value={referenceNumber || ""}
                        onChange={(e) => {
                          setReferenceNumber(e.target.value);
                          setreferenceError(false);
                        }}
                        required
                      />
                      {referenceError && (
                        <div className="error-message">
                          <FontAwesomeIcon
                            className="me-1"
                            icon={faCircleExclamation}
                          />
                          UEN/Indentification number should not be empty.
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col-lg-3">
                      <label className="col-form-label">Invoice Date</label>
                    </div>
                    <div className="col-lg-1">
                      <label className="col-form-label">From</label>
                    </div>
                    <div className="col-lg-3">
                      <input
                        type="date"
                        value={dateFrom}
                        className="form-control"
                        max={getTodayDate()}
                        onChange={(e) => {
                          setDateFrom(e.target.value);
                          setDateTo("");
                          setShowError(false);
                        }}
                        required
                      />
                    </div>
                    <div className="col-lg-1">
                      <label className="col-form-label">To</label>
                    </div>
                    <div className="col-lg-3">
                      <input
                        type="date"
                        value={dateTo}
                        className="form-control"
                        onChange={(e) => {
                          setDateTo(e.target.value);
                          setShowError(false);
                        }}
                        min={dateFrom ? getNextDay(dateFrom) : ""}
                        max={getTodayDate()}
                        required
                      />
                    </div>
                  </div>

                  {showError && (
                    <div className="row mb-3">
                      <div className="col-lg-3"></div>
                      <div className="col-lg-9 text-danger">
                        Please enter both From and To dates
                      </div>
                    </div>
                  )}

                  <div className="row">
                    <div className="col-lg-12">
                      <button
                        type="button"
                        className={`custom-search-button ${
                          searchLoading ? "loading" : ""
                        }`}
                        onClick={handleSearch}
                        disabled={searchLoading}
                      >
                        {searchLoading ? "Searching..." : "Search"}
                      </button>
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={handleReset}
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>

        <div className="mt-3">
          <br />
          {pageLoading ? <Loader /> : null}
          {showGrid && data.length > 0 && (
            <InvoiceGrid
              data={data}
              isLoading={isLoading}
              headerColumns={headers}
              setData={setData}
              zipdata={zipdata}
              fromDate={dateFrom}
              toDate={dateTo}
            />
          )}
        </div>
      </Container>
      <Footer />
    </>
  );
};

export default InvoiceDashboard;
